import { render } from "./CardChallengeResultDeclarationIncomplete.vue?vue&type=template&id=61fb65d6&scoped=true"
import script from "./CardChallengeResultDeclarationIncomplete.vue?vue&type=script&lang=js"
export * from "./CardChallengeResultDeclarationIncomplete.vue?vue&type=script&lang=js"

import "@/css/components/card-challenge-result-declaration-incomplete.css?vue&type=style&index=0&id=61fb65d6&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fb65d6"]])

export default __exports__